import React from 'react'
import { Box, Dialog, DialogTitle, DialogContent } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useMutation } from '@apollo/react-hooks'

import { CorporateForm, ICorporateFormValues } from './CorporateForm'
import { UPDATE_CORPORATIONS, GET_CORPORATIONS_BY_ADMIN } from '../../../graphql/queries/businesses'
import { ICorporation } from '../../../graphql/types/businesses'
import { CORPORATIONS_ROWS_PER_PAGE } from '../../../graphql/hooks/businesses'

interface IProps {
  open: boolean
  corporation: ICorporation
  onCancel: () => void
}

export const EditCorporateModal: React.FC<IProps> = ({ open, corporation, onCancel }) => {
  const [error, setError] = React.useState<string | undefined>(undefined)
  const [updateCorporation, { loading }] = useMutation(UPDATE_CORPORATIONS, {
    refetchQueries: [
      {
        query: GET_CORPORATIONS_BY_ADMIN,
        variables: {
          pagination: { offset: 0, limit: CORPORATIONS_ROWS_PER_PAGE[0] },
        },
      },
    ],
  })

  const handleSubmit = async (values: ICorporateFormValues) => {
    try {
      await updateCorporation({
        variables: {
          id: corporation.id,
          input: {
            corporationName: values.corporationName,
            countryId: values.countryId ?? undefined,
            citiesIds: values.citiesIds ?? undefined,
          },
        },
      })
      onCancel()
    } catch (error) {
      setError((error as Error).message || 'Произошла ошибка')
    }
  }

  return (
    <Dialog open={open} maxWidth='sm' fullWidth>
      <DialogTitle id='form-dialog-title'>Изменить корпорацию</DialogTitle>
      <DialogContent>
        {!!error && (
          <Box mb={3}>
            <Alert severity='error'>{error}</Alert>
          </Box>
        )}
        <Box>
          <CorporateForm loading={loading} corporation={corporation} onSubmit={handleSubmit} onCancel={onCancel} />
        </Box>
      </DialogContent>
    </Dialog>
  )
}
